import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/c9348fc5-36f4-40f8-a1ec-60bd84d37535",
        "alt": "An image displaying a testimonial anatomy."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Quote: The quote from the customer.`}</li>
      <li parentName="ul">{`Name: The name of the customer.`}</li>
      <li parentName="ul">{`Position: The position or role of the customer.`}</li>
      <li parentName="ul">{`Avatar or Logo: Optional avatar of the customer or the company logo.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the testimonial component to showcase a quote or a review from a customer. Use the testimonials to build credibility, trust, and provide social proof by displaying customers' sentiments about the product.`}</p>
    <p>{`Testimonials should be short and concise. Quotes should be not be longer than 3-4 lines. Avoid using long quotes that can be hard to understand or that don't provide enough context.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/dd1a3e57-d94f-4f62-9840-67fce2cd78d2" />
    <Caption mdxType="Caption">Use short and concise quotes.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/e6c7e682-9948-4238-bc74-f26d705cce65" />
    <Caption mdxType="Caption">
      Don't use long quotes that can be hard to read and understand.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Avatars and logos are optional and can be used to provide more credibility about the customer or the company. When using an avatar, use an image of the customer to make the testimonial more personal. If an image is not available, use a logo or a similar visual asset that represents the customer company or the organization.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/8968b579-1ff6-490e-a5a2-2abd2da588e5" />
    <Caption mdxType="Caption">
      Use a real life image of the customer or the logo of the company.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/bcda5e31-1ccc-44a5-9d65-2f6aad326f4b" />
    <Caption mdxType="Caption">
      Don't use illustrations or generic images. Use real life images to provide
      trust.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Testimonials can be used individually or in a group. When using a group of testimonials, use the same size and alignment for all of them. When including an avatar or a logo, use them in all testimonials of the group and keep the same style and size— don't alternate between logos and avatars. We recommend using a maximum of 4 testimonials per group to avoid visual noise and to keep the quotes relevant.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/06a41538-6fca-4145-b1f5-7de16a8e078d" />
    <Caption mdxType="Caption">
      Use a maximum of 3 or 4 testimonials per group, with the same size and
      alginment.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/ed834a59-65e9-4933-a9c7-ace37843c7a6" />
    <Caption mdxType="Caption">
      Don't use different sizes, alignments or alternate avatars and logos for
      groups of testimonials.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`Use a single testimonial to highlight a specific feature or benefit of the product. Use multiple testimonials to showcase each feature when in a list or a `}<a parentName="p" {...{
        "href": "/components/River"
      }}>{`river`}</a>{`.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/d59eff28-6db4-4f7a-a8c4-8fb69716edd7" />
    <Caption mdxType="Caption">
      Use testimonials to enhance the credibility of an specific feature or
      benefit.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/7888cd46-6397-4a6f-8f62-63d3236f0a5c" />
    <Caption mdxType="Caption">
      Don't use multiple testimonials to showcase the same feature to avoid
      visual noise.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Size`}</h3>
    <p>{`The testimonial component uses the small size by default. Use the large size to provide more visual weight.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/a10d6454-0b6e-4694-9acc-cdf48e31d922" />
    <Caption mdxType="Caption">
      Use the large size when using a single, full-width testimonial.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/34a502ea-4b32-4054-9518-4da63d86acf9" />
    <Caption mdxType="Caption">Don't use small size for full-width testimonials.</Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/91ee4072-41a3-4984-9af5-9c6f9b94135c" />
    <Caption mdxType="Caption">
      Use the small size when paired with other components that showcase
      features, like rivers.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/63143585-1c28-4380-853d-a6e5dff6f8c1" />
    <Caption mdxType="Caption">
      Don't use the large size in small sized areas or components like rivers,
      so they don't conflict with the main content. Even if the quote is short,
      use the small size instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/20e90276-8b6c-4e14-911b-f28b38eb7f7b" />
    <Caption mdxType="Caption">Use the small size for single row groups of testimonials.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/136e559e-aa04-4814-99f7-f1f722ebb8e6" />
    <Caption mdxType="Caption">
      Don't use the large size in single row groups, even if the content is
      short. Stack them vertically and use 2 columns instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display related content with less visual emphasis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Card"
        }}>{`Card`}</a>{`: To display navigational related content with higher visual weight.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display navigational related content with higher visual weight.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      